if (!customElements.get('fu-promotions-entry')) {
  customElements.define('fu-promotions-entry', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe?.();
      this.unsubscribe = window.FUPromotions.subscribe(state => {
        const available = state.records.length > 0;
        this.hidden = !available;
        if (available && !this.started) { this.started = true; this.startPopup(); }
        if (!available) { clearTimeout(this.openTimer); clearTimeout(this.closeTimer); if (this.popup) this.popup.hidden = true; }
      });
    }
    startPopup() {
      this.popup = this.querySelector('[data-promo-popup]');
      if (!this.popup || window.Shopify?.designMode) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.key = `fu-promotions-seen:${this.dataset.campaign}`;
      try { if (sessionStorage.getItem(this.key)) return; } catch {}
      this.querySelectorAll('[data-promo-close]').forEach(button => button.addEventListener('click', () => this.dismiss(), options));
      this.popup.addEventListener('pointerenter', () => clearTimeout(this.closeTimer), options);
      this.popup.addEventListener('pointerleave', () => this.scheduleClose(), options);
      this.popup.addEventListener('focusin', () => clearTimeout(this.closeTimer), options);
      this.popup.addEventListener('focusout', () => this.scheduleClose(), options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.popup.hidden) this.dismiss();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) clearTimeout(this.closeTimer);
        else this.scheduleClose();
      }, options);
      this.openTimer = setTimeout(() => this.show(), Number(this.dataset.delay) * 1000);
    }
    show() {
      if (!this.isConnected) return;
      if (document.hidden || document.querySelector('dialog[open]')) {
        this.openTimer = setTimeout(() => this.show(), 2000);
        return;
      }
      this.popup.hidden = false;
      this.popup.classList.add('is-open');
      try { sessionStorage.setItem(this.key, '1'); } catch {}
      this.scheduleClose();
    }
    scheduleClose() {
      clearTimeout(this.closeTimer);
      if (!this.popup || this.popup.hidden || document.hidden) return;
      this.closeTimer = setTimeout(() => {
        if (this.popup.contains(document.activeElement) || this.popup.matches(':hover')) return;
        this.dismiss();
      }, Number(this.dataset.duration) * 1000);
    }
    dismiss() {
      clearTimeout(this.closeTimer);
      clearTimeout(this.openTimer);
      if (this.closing || !this.popup || this.popup.hidden) return;
      this.closing = true;
      const bar = this.querySelector('[data-promo-bar]');
      if (this.popup.contains(document.activeElement)) bar.querySelector('a')?.focus({ preventScroll: true });
      const finish = () => {
        this.popup.hidden = true;
        this.closing = false;
        bar.classList.add('is-highlighted');
      };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || !this.popup.animate) return finish();
      const destination = bar.getBoundingClientRect();
      const source = this.popup.getBoundingClientRect();
      const distance = Math.max(-200, Math.min(0, destination.top - source.top));
      const animation = this.popup.animate([{ opacity: 1, transform: 'translateY(0) scale(1)' }, { opacity: 0, transform: `translateY(${distance}px) scale(.94)` }], { duration: 300, easing: 'ease-in', fill: 'forwards' });
      animation.finished.then(() => { finish(); animation.cancel(); }).catch(finish);
    }
    disconnectedCallback() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.controller?.abort();
      this.unsubscribe?.();
    }
  });
}

